import { render } from "./PageMethodologie.vue?vue&type=template&id=6800085e"
import script from "./PageMethodologie.vue?vue&type=script&lang=js"
export * from "./PageMethodologie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__